/**
 * Tooltips
 * 
 * Simple tooltip system that uses 
 * aria attributes for accessibility.
 * 
 * @author Co-Pilot, matt.breiwick
 */
export default function initTooltips() {
    document.querySelectorAll('a[aria-describedby]').forEach(function (link) {
        if (!link) return;

        const tooltipId = link.getAttribute('aria-describedby');
        const tooltip = document.getElementById(tooltipId);
        const links = getLinksForTooltip(tooltipId);

        if (!tooltip) return;

        function showTooltip() {
            if (link.hasAttribute('data-swiper-active')) return;
            tooltip.hidden = false;
            // tooltip.setAttribute('aria-expanded', 'true');
            links.forEach(link => link.classList.add('--active'));
        }

        function hideTooltip() {
            if (link.hasAttribute('data-swiper-active')) return;

            tooltip.hidden = true;
            // tooltip.setAttribute('aria-expanded', 'false');
            links.forEach(link => link.classList.remove('--active'));
        }

        link.addEventListener('mouseenter', showTooltip);
        link.addEventListener('focus', showTooltip);
        link.addEventListener('mouseleave', hideTooltip);
        link.addEventListener('blur', hideTooltip);
    });



    /**
     * Get all links for a given tooltip
     *
     * Return all <a> elements that reference a 
     * given tooltip id via aria-describedby
     * 
     * @param {string} tooltipId
     * @returns {HTMLElement[]} array of matching <a> elements
     * 
     * @author Co-Pilot, matt.breiwick
     */
    function getLinksForTooltip(tooltipId) {
        if (!tooltipId) return [];
        return Array.from(document.querySelectorAll('a[aria-describedby="' + tooltipId + '"]'));
    }
}